import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import NotFound from "@/views/error/404.vue";
import Forbidden from "@/views/error/403.vue";
import Main from "@/views/main.vue";
import Login from "@/views/login.vue";
import Agree from "@/views/agree.vue";
import Statistics from "@/views/statistics/index.vue";
import AccountManagement from "@/views/user/management.vue";
import SearchList from "@/views/search/list.vue";
import SearchResult from "@/views/search/result.vue";
import Monitoring from "@/views/search/monitor.vue";

import WatcherBot from "@/views/watcherbot/aiSearch/list.vue";
import WatcherBotResult from "@/views/watcherbot/aiSearch/result.vue";

import WatcherBot_Search from "@/views/watcherbot/search/index.vue";
import WatcherBot_List from "@/views/watcherbot/search/list.vue";
import WatcherBot_Result from "@/views/watcherbot/search/result.vue";
import WatcherBot_Statistics from "@/views/watcherbot/statistics/index.vue";

import ApiChargeLog from "@/views/api/chargeLog.vue";

import { userStore } from "@/BaseComponent";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/login",
        name: "Login",
        component: Login,
    },
    {
        path: "/agree",
        name: "Agree",
        component: Agree,
    },
    {
        path: "/",
        name: "Main",
        component: Main,
        meta: { requiresAuth: true },
    },
    {
        path: "/search/history",
        name: "SearchManagement",
        component: SearchList,
        meta: { requiresAuth: true },
    },
    {
        path: "/search/result/:idx",
        name: "SearchResult",
        component: SearchResult,
        meta: { requiresAuth: true },
    },
    {
        path: "/monitoring",
        name: "Monitoring",
        component: Monitoring,
        meta: { requiresAuth: true },
    },
    {
        path: "/statistics",
        name: "Statistics",
        component: Statistics,
        meta: { requiresAuth: true },
    },

    {
        path: "/management/account",
        name: "AccountManagement",
        component: AccountManagement,
        meta: { requiresAuth: true, isAdmin: true },
    },
    {
        path: "/status/user",
        name: "UserStatus",
        component: NotFound, //사용자 통계 삭제
        meta: { requiresAuth: true },
    },
    {
        path: "/ai/watcher_bot",
        name: "WatcherBot",
        component: WatcherBot,
        meta: { requiresAuth: true },
    },
    {
        path: "/ai/watcher_bot/result/:idx",
        name: "WatcherBotResult",
        component: WatcherBotResult,
        meta: { requiresAuth: true },
    },
    {
        path: "/watcherbot/search",
        name: "WatcherBot_Search",
        component: WatcherBot_Search,
        meta: { requiresAuth: true },
    },
    {
        path: "/watcherbot/search/history",
        name: "WatcherBot_List",
        component: WatcherBot_List,
        meta: { requiresAuth: true },
    },
    {
        path: "/watcherbot/result",
        name: "WatcherBot_Result",
        component: WatcherBot_Result,
        meta: { requiresAuth: true },
    },
    {
        path: "/watcherbot/statistics",
        name: "WatcherBot_Statistics",
        component: WatcherBot_Statistics,
        meta: { requiresAuth: true },
    },
    {
        path: "/api/charge/log",
        name: "ApiChargeLog",
        component: ApiChargeLog,
        meta: { requiresAuth: true },
    },
    {
        path: "/403",
        name: "Forbidden",
        component: Forbidden,
    },
    {
        path: "/:pathMatch(.*)*", // catch-all 경로
        name: "NotFound",
        component: NotFound,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

// 라우터 네비게이션 가드 설정
router.beforeEach((to, from, next) => {
    const user = userStore();
    // const author = inject("author") as any;
    const isLoggedIn = user !== null && user.token !== "" && user.token !== null;
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // 해당 라우트에 인증이 필요한 경우
        if (!isLoggedIn) {
            // 로그인이 되어 있지 않은 경우
            next({ name: "Login" }); // 로그인 페이지로 이동
        } else {
            if (to.matched.some((record) => record.meta.isAdmin) && user.userInfo.clfCd !== 99) {
                next({ name: "NotFound", replace: true });
            } else {
                next(); // 다음 단계로 이동
            }
        }
    } else {
        next(); // 인증이 필요하지 않은 경우 다음 단계로 이동
    }
});

export default router;
